export default __webpack_public_path__ + "static/media/Melanie_Studer_AHV_In_Moms_We_Trust.99172de5.jpg";